import React, { useState, useEffect, useMemo, useRef, FunctionComponent } from 'react';
import { matchPath, Outlet, useLocation, Navigate } from 'react-router-dom';
import { useAppSelector } from 'app/hooks';
import { BackofficeState } from 'features/backoffice/backofficeSlice';

import SideBar from './SideBar';
import Navbar from './Navbar';

const BackofficeLayout: FunctionComponent = () => {
  const { logged } = useAppSelector(
    ({ backoffice }: { backoffice: BackofficeState }) => backoffice
  );
  if (!logged) {
    return <Navigate to="/" replace />;
  }
  useEffect(() => {
    document.body.classList.add('backoffice');
    return () => {
      document.body.classList.remove('backoffice');
    };
  }, []);

  return (
    <div className="unify-admin-wrapper h-100">
      <main className="d-flex flex-row h-100 w-100">
        <SideBar />
        <section className="d-flex px-5 w-100">
          <Outlet />
        </section>
      </main>
    </div>
    // <div className={styles.layout} id="backofficeLayout">
    //   <SideBar />
    //   <div className="d-flex flex-column w-100">
    //     <Navbar />
    //     <div className="container-fluid">
    //       <Outlet />
    //     </div>
    //   </div>
    // </div>
  );
};

export default BackofficeLayout;
